const uuid = require('uuid')
import i18n from "./../../i18n/i18nApp";
import productsInDb from '../../assets/data/productDB.json'

const state = {
    busDeviceItems: [],
    busMajorDeviceItems: []
}


const mutations = {
    UPDATE_SINGE_DEVICE_ITEM(state, payload) {
        let index = state.busDeviceItems.findIndex(obj => obj.id == payload.id);
        state.busDeviceItems[index] = payload
    },
    UPDATE_MAJOR_DEVICE_ITEM(state, payload) {
        let index = state.busMajorDeviceItems.findIndex(obj => obj.id == payload.id);
        state.busMajorDeviceItems[index] = payload
    },
    UPDATE_DEVICE_ITEMS(state, payload) {
        state.busDeviceItems = payload
    },
    UPDATE_MAJOR_DEVICE_ITEMS(state, payload) {
        state.busMajorDeviceItems = payload
    },
    ADD_DEVICE_ITEM(state, payload) {
        state.busDeviceItems.push(payload);
    },
    REMOVE_DEVICE_ITEM(state, payload) {
        let index = state.busDeviceItems.findIndex(obj => obj.id == payload.id);
        state.busDeviceItems.splice(index,1);
    }

};

const actions = {
    updateItem({commit},payload) {
        commit('UPDATE_SINGE_DEVICE_ITEM', payload)
    },
    updateMajorItem({commit},payload) {
        commit('UPDATE_MAJOR_DEVICE_ITEM', payload)
    },
    addDevice({commit},payload) {
        let newID = uuid.v4()
        payload.id = newID;
        commit('ADD_DEVICE_ITEM',payload)
    },
    removeDevice({commit}, payload) {
        commit('REMOVE_DEVICE_ITEM', payload)
    },
    clearDeviceList({commit}) {
        commit('UPDATE_DEVICE_ITEMS', [])
    },
    updateDeviceList({commit}, payload) {
        commit('UPDATE_DEVICE_ITEMS', payload)
    },
    updateMajorDeviceList({commit}, payload) {
        commit('UPDATE_MAJOR_DEVICE_ITEMS', payload)
    },
    createNewDeviceList(blubb, controller) {
        this.dispatch('busDevice/clearDeviceList')
        let controlGear = {
            name: i18n.global.t('participantGui.controlGear'),
            typeCategory: 1,
            current: 2,
            amount: null
        }
        this.dispatch('busDevice/addDevice', controlGear)
        if(controller.slaveSensorTechnologie !== null) {
            let sensorDevice = {
                name: i18n.global.t('participantGui.sensor'),
                typeCategory: 2,
                current: 7,
                amount: null
            }
            // Prüfe ob es ein DAA4G ist, wenn ja erhöhe den Stromverbrauch auf 14
            if(controller.productNo == 92743 || controller.productNo == 92591) {
                sensorDevice.current = 14
            }
            this.dispatch('busDevice/addDevice', sensorDevice)
        }
        if(controller.slaveInputTechnologie !== null) {
            let inputDevice = {
                name: i18n.global.t('participantGui.inputDevice'),
                typeCategory: 3,
                current: 7,
                amount: null
            }
            this.dispatch('busDevice/addDevice', inputDevice)
        }
    },
    createMajorProducts({commit}, payload) {
        if(payload === undefined) {
            return;
        }
        let products = []
        if(payload.selectedApplicationController.systemCategory == "daliLink") {
            let pbm =  productsInDb.find(obj => obj.productNo == 92732)
            pbm.amount = 1
            pbm.name = pbm.productNo + " " + i18n.global.t('products.'+pbm.productNo+".name")
            pbm.current  = pbm.daliCurrentNeed
            pbm.typeCategory = 3;
            products.push(pbm)
        }
        if(payload.calculationResult.powerExtenderIsNeed == true) {
            let extender =  productsInDb.find(obj => obj.productNo == 92846)
            extender.amount = 1
            extender.name = extender.productNo + " " + i18n.global.t('products.'+extender.productNo+".name")
            extender.current  = 0
            extender.typeCategory = 1;
            products.push(extender)
        }
        commit('UPDATE_MAJOR_DEVICE_ITEMS', products)
        //this.$store.dispatch('busDevice/updateMajorDeviceList', products)
    }

};

const getters = {
    getAllItems: state => state.busDeviceItems,
    getAllMajorItems: state => state.busMajorDeviceItems,
    getControlGearItems: state => state.busDeviceItems.filter(obj => obj.typeCategory == 1),
    getSensorItems: state => state.busDeviceItems.filter(obj => obj.typeCategory == 2),
    getInputItems: state => state.busDeviceItems.filter(obj => obj.typeCategory == 3),
    getCalculationResult: state => state.calculationResult
};

const namespaced = true;

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced
};
